import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientNotificationHandlerService, NotificationService } from '@thehubz/client/core';
import { AuthApiService } from '@thehubz/client/data-access-api';

@Component({
  selector: 'thehubz-reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss']
})
export class ResetPasswordEmailComponent implements OnInit {
  resetPasswordGroup!: UntypedFormGroup;
  loading = false;
  disableResetPwdBtn = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthApiService,
    private notification: NotificationService,
    private clientNotificationHandlerService: ClientNotificationHandlerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.resetPasswordGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  resetPassword() {
    this.loading = true;
    this.disableResetPwdBtn = true;
    this.authService.authControllerForgotPassword(this.resetPasswordGroup.value).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.disableResetPwdBtn = false;
        if (res.message) {
          this.notification.addNotification({
            type: 'info',
            message: res.message,
          });
        } else if (res.error) {
          this.notification.addNotification({
            type: 'info',
            message: res.error,
          });
        }
       
      },
      error: (err) => {
        this.loading = false;
        this.disableResetPwdBtn = false;
        this.clientNotificationHandlerService.errorNotification(err);
      },
    });
  }

  backToLogin() {
    this.router.navigate(['login']);
  }
}
